import React from "react";
import NewsArticleLayout from "../../../components/updated-article/NewsArticleLayout.component";

const isNew = true;
const href = "/ratesheet/20221208-Rate-Sheet.pdf";
const date = "08.12.2022";

const Article = () => (
  <NewsArticleLayout href={href} date={date} isNew={isNew}>
    <h1 className="page-title">Changes to our mortgage products</h1>

    <br />
    <p>With effect from Thursday 8 December 2022 we will be making the following changes to our range</p>
    <p>Summary of changes</p>
    <p>
      <strong>Residential Existing Customer Switching Range</strong>
    </p>
    <ul>
      <li>5 Year Fixed Fee Saver at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70% and 75% LTV have reduced </li>
      <li>2 Year Tracker Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced </li>
      <li>2 Year Tracker Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
    </ul>
    <p>
      <strong>Residential Existing Customer Borrowing More Range</strong>
    </p>
    <ul>
      <li>5 Year Fixed Fee Saver at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70% and 75% LTV have reduced </li>
      <li>2 Year Tracker Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
    </ul>
    <p>
      <strong>Residential First Time Buyer Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75% and 85% LTV have reduced</li>
      <li>2 Year Fixed Standard at 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60% and 90% LTV have reduced</li>
      <li>5 Year Fixed Premier Exclusive at 60% and 90% LTV have reduced</li>
      <li>2 Year Tracker Standard at 60%, 70%, 75%, 80% and 85% LTV have reduced</li>
    </ul>
    <p>
      <strong>Residential Remortgage Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75%,80% and 85% LTV have reduced</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced </li>
      <li>5 Year Fixed Standard at 60%, 70%, 75% and 80% LTV have reduced</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70%, 75% and 80% LTV have reduced</li>
      <li>2 Year Tracker Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
    </ul>
    <p>
      <strong>Residential Home Mover Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75% and 85% LTV have reduced</li>
      <li>2 Year Fixed Standard at 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60% and 90% LTV have reduced</li>
      <li>5 Year Fixed Premier Exclusive at 60% and 90% LTV have reduced</li>
      <li>2 Year Tracker Standard at 60%, 70%, 75%, 80% and 85% LTV have reduced</li>
    </ul>
    <p>
      <strong>UK Buy to Let Purchase Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Tracker Fee Saver at 60%, 65% and 75% LTV have reduced </li>
      <li>2 Year Tracker Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>
    <p>
      <strong>UK Buy to Let Remortgage Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Tracker Fee Saver at 60%, 65% and 75% LTV have reduced </li>
      <li>2 Year Tracker Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>
    <p>
      <strong>UK Buy to Let Existing Customers Switching Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Tracker Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>
    <p>
      <strong>UK Buy to Let Existing Customer Borrowing More Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Tracker Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>
    <p>
      <strong>International Residential Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60% LTV has reduced</li>
      <li>5 Year Fixed Premier Exclusive at 60% LTV has reduced</li>
      <li>2 Year Tracker Standard at 60%, 70% and 75% LTV have reduced</li>
    </ul>
    <p>There are no changes to fixed rate end dates or to any other interest rates at this time.</p>
    <p>An updated mortgage rate sheet will be published on Thursday 8 December to reflect these changes.</p>
  </NewsArticleLayout>
);

export default Article;
